import useragent from 'useragent';

export const formatName = string => {
  return string.toLowerCase().replace(' ', '_');
};

export const isOkBrowser = (agent, list) => {
  const parseAgent = useragent.parse(agent);

  const browser = list.find(
    brwsr => brwsr.name === formatName(parseAgent.family)
  );
  if (browser && browser.version <= parseInt(parseAgent.major)) return true;
  return false;
};
